// // // import { useState, useEffect, useCallback } from "react";
// // // import { useNavigate } from "react-router-dom";
// // // import {
// // //   Box,
// // //   Typography,
// // //   Button,
// // //   Grid,
// // //   CircularProgress,
// // //   Alert,
// // //   alpha,
// // // } from "@mui/material";
// // // import AddIcon from "@mui/icons-material/Add";
// // // import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
// // // import { useATS } from "../context/ATSContext";
// // // import { jobService } from "../services/jobService";
// // // import JobCard from "../components/JobCard";
// // // import JobCreationModal from "../components/JobCreationModal";

// // // // Blue palette
// // // const BLUE = {
// // //   50: "#eff6ff",
// // //   100: "#dbeafe",
// // //   200: "#bfdbfe",
// // //   300: "#93c5fd",
// // //   400: "#60a5fa",
// // //   500: "#3b82f6",
// // //   600: "#2563eb",
// // //   700: "#1d4ed8",
// // //   800: "#1e40af",
// // //   900: "#1e3a8a",
// // // };

// // // // Keyframes for fade-up animation (inject once)
// // // if (
// // //   typeof document !== "undefined" &&
// // //   !document.getElementById("dashboard-keyframes")
// // // ) {
// // //   const style = document.createElement("style");
// // //   style.id = "dashboard-keyframes";
// // //   style.textContent = `
// // //     @keyframes fadeUp {
// // //       from { opacity: 0; transform: translateY(20px); }
// // //       to { opacity: 1; transform: translateY(0); }
// // //     }
// // //   `;
// // //   document.head.appendChild(style);
// // // }

// // // const fontFam = "'Plus Jakarta Sans', 'Inter', sans-serif";

// // // const Dashboard = () => {
// // //   const navigate = useNavigate();
// // //   const { store_id, refreshTrigger } = useATS();
// // //   const [jobs, setJobs] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [error, setError] = useState(null);
// // //   const [modalOpen, setModalOpen] = useState(false);

// // //   const fetchJobs = useCallback(async () => {
// // //     if (store_id === undefined) return;
// // //     try {
// // //       setLoading(true);
// // //       const response = await jobService.getAllJobs(store_id);
// // //       setJobs(response.data.data || []);
// // //       setError(null);
// // //     } catch (err) {
// // //       console.error(err);
// // //       setError("Failed to load jobs. Please try again.");
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   }, [store_id]);

// // //   useEffect(() => {
// // //     fetchJobs();
// // //   }, [fetchJobs, refreshTrigger]);

// // //   const handleCreateJob = () => setModalOpen(true);
// // //   const handleJobCreated = () => {
// // //     fetchJobs();
// // //     setModalOpen(false);
// // //   };

// // //   if (store_id === undefined) {
// // //     return (
// // //       <Box sx={{ textAlign: "center", py: 8 }}>
// // //         <Typography variant="h6" color="text.secondary" fontFamily={fontFam}>
// // //           Please log in to access the ATS dashboard.
// // //         </Typography>
// // //       </Box>
// // //     );
// // //   }

// // //   return (
// // //     <Box sx={{ fontFamily: fontFam, px: { sm: 8 } }}>
// // //       {/* Header Section */}
// // //       <Box
// // //         sx={{
// // //           display: "flex",
// // //           justifyContent: "space-between",
// // //           alignItems: "flex-start",
// // //           mb: 5,
// // //           flexWrap: "wrap",
// // //           gap: 2,
// // //           animation: "fadeUp 0.4s ease both",
// // //         }}
// // //       >
// // //         <Box>
// // //           <Typography
// // //             variant="h4"
// // //             sx={{
// // //               fontWeight: 800,
// // //               color: "#fff",
// // //               mb: 1,
// // //               letterSpacing: 2,
// // //               fontFamily: "system-ui",
// // //               fontSize: 56,
// // //             }}
// // //           >
// // //             Hiring Dashboard
// // //           </Typography>
// // //           <Typography
// // //             variant="body1"
// // //             color="#e9e9e9"
// // //             sx={{ maxWidth: 550, fontFamily: "monospace" }}
// // //           >
// // //             Manage all your active job postings, track candidates, and
// // //             streamline your hiring process.
// // //           </Typography>
// // //         </Box>

// // //         <Button
// // //           variant="contained"
// // //           startIcon={<AddIcon />}
// // //           onClick={handleCreateJob}
// // //           sx={{
// // //             borderRadius: "40px",
// // //             px: 3,
// // //             py: 1.2,
// // //             textTransform: "none",
// // //             fontWeight: 600,
// // //             background: "#fff",
// // //             color: "#0c8a9b",
// // //             boxShadow: `0 4px 14px ${alpha(BLUE[500], 0.25)}`,
// // //             "&:hover": {
// // //               transform: "translateY(-2px)",
// // //               boxShadow: `0 8px 20px ${("#0c8a9b", 0.35)}`,
// // //               background: "#ace8f0",
// // //               color: "#fff",
// // //             },
// // //             transition: "all 0.2s ease",
// // //           }}
// // //         >
// // //           Create New Job
// // //         </Button>
// // //       </Box>

// // //       {/* Loading State */}
// // //       {loading ? (
// // //         <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
// // //           <CircularProgress sx={{ color: BLUE[600] }} />
// // //         </Box>
// // //       ) : error ? (
// // //         <Alert severity="error" sx={{ borderRadius: "20px" }}>
// // //           {error}
// // //         </Alert>
// // //       ) : jobs.length === 0 ? (
// // //         // Empty State
// // //         <Box
// // //           sx={{
// // //             textAlign: "center",
// // //             py: 8,
// // //             bgcolor: "#ffffff",
// // //             borderRadius: "32px",
// // //             border: `1px solid ${BLUE[100]}`,
// // //             boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
// // //             animation: "fadeUp 0.5s ease both",
// // //           }}
// // //         >
// // //           <WorkOutlineIcon sx={{ fontSize: 64, color: BLUE[200], mb: 2 }} />
// // //           <Typography
// // //             variant="h6"
// // //             fontWeight={600}
// // //             color="#0f172a"
// // //             gutterBottom
// // //           >
// // //             No jobs created yet
// // //           </Typography>
// // //           <Typography variant="body2" color="#64748b">
// // //             Click "Create New Job" to start hiring
// // //           </Typography>
// // //         </Box>
// // //       ) : (
// // //         // Jobs Grid
// // //         <Grid container spacing={3}>
// // //           {jobs.map((job, idx) => (
// // //             <Grid
// // //               item
// // //               xs={12}
// // //               sm={6}
// // //               md={4}
// // //               key={job.id}
// // //               sx={{ animation: `fadeUp 0.4s ease ${idx * 0.05}s both` }}
// // //             >
// // //               <JobCard
// // //                 job={job}
// // //                 onViewCandidates={() => navigate(`/ats/job/${job.id}`)}
// // //               />
// // //             </Grid>
// // //           ))}
// // //         </Grid>
// // //       )}

// // //       <JobCreationModal
// // //         open={modalOpen}
// // //         onClose={() => setModalOpen(false)}
// // //         onJobCreated={handleJobCreated}
// // //       />
// // //     </Box>
// // //   );
// // // };

// // // export default Dashboard;
// // import { useState, useEffect, useCallback } from "react";
// // import { useNavigate } from "react-router-dom";
// // import {
// //   Box,
// //   Typography,
// //   Button,
// //   Grid,
// //   CircularProgress,
// //   Alert,
// //   alpha,
// // } from "@mui/material";
// // import AddIcon from "@mui/icons-material/Add";
// // import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
// // import { useATS } from "../context/ATSContext";
// // import { jobService } from "../services/jobService";
// // import JobCard from "../components/JobCard";
// // import JobCreationModal from "../components/JobCreationModal";

// // const BLUE = {
// //   50: "#eff6ff",
// //   100: "#dbeafe",
// //   200: "#bfdbfe",
// //   300: "#93c5fd",
// //   400: "#60a5fa",
// //   500: "#3b82f6",
// //   600: "#2563eb",
// //   700: "#1d4ed8",
// //   800: "#1e40af",
// //   900: "#1e3a8a",
// // };

// // if (
// //   typeof document !== "undefined" &&
// //   !document.getElementById("dashboard-keyframes")
// // ) {
// //   const style = document.createElement("style");
// //   style.id = "dashboard-keyframes";
// //   style.textContent = `
// //     @keyframes fadeUp {
// //       from { opacity: 0; transform: translateY(20px); }
// //       to { opacity: 1; transform: translateY(0); }
// //     }
// //   `;
// //   document.head.appendChild(style);
// // }

// // const fontFam = "'Plus Jakarta Sans', 'Inter', sans-serif";

// // const Dashboard = () => {
// //   const navigate = useNavigate();
// //   const { store_id, refreshTrigger } = useATS();
// //   const [jobs, setJobs] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [editJob, setEditJob] = useState(null); // job being edited

// //   const fetchJobs = useCallback(async () => {
// //     if (store_id === undefined) return;
// //     try {
// //       setLoading(true);
// //       const response = await jobService.getAllJobs(store_id);
// //       setJobs(response.data.data || []);
// //       setError(null);
// //     } catch (err) {
// //       console.error(err);
// //       setError("Failed to load jobs. Please try again.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [store_id]);

// //   useEffect(() => {
// //     fetchJobs();
// //   }, [fetchJobs, refreshTrigger]);

// //   const handleCreateJob = () => {
// //     setEditJob(null); // ensure it's create mode
// //     setModalOpen(true);
// //   };

// //   const handleJobCreated = () => {
// //     fetchJobs();
// //     setModalOpen(false);
// //     setEditJob(null);
// //   };

// //   const handleJobUpdated = () => {
// //     fetchJobs();
// //     setModalOpen(false);
// //     setEditJob(null);
// //   };

// //   if (store_id === undefined) {
// //     return (
// //       <Box sx={{ textAlign: "center", py: 8 }}>
// //         <Typography variant="h6" color="text.secondary" fontFamily={fontFam}>
// //           Please log in to access the ATS dashboard.
// //         </Typography>
// //       </Box>
// //     );
// //   }

// //   return (
// //     <Box sx={{ fontFamily: fontFam, px: { sm: 8 } }}>
// //       {/* Header Section */}
// //       <Box
// //         sx={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "flex-start",
// //           mb: 5,
// //           flexWrap: "wrap",
// //           gap: 2,
// //           animation: "fadeUp 0.4s ease both",
// //         }}
// //       >
// //         <Box>
// //           <Typography
// //             variant="h4"
// //             sx={{
// //               fontWeight: 800,
// //               color: "#fff",
// //               mb: 1,
// //               letterSpacing: 2,
// //               fontFamily: "system-ui",
// //               fontSize: 56,
// //             }}
// //           >
// //             Hiring Dashboard
// //           </Typography>
// //           <Typography
// //             variant="body1"
// //             color="#e9e9e9"
// //             sx={{ maxWidth: 550, fontFamily: "monospace" }}
// //           >
// //             Manage all your active job postings, track candidates, and
// //             streamline your hiring process.
// //           </Typography>
// //         </Box>

// //         <Button
// //           variant="contained"
// //           startIcon={<AddIcon />}
// //           onClick={handleCreateJob}
// //           sx={{
// //             borderRadius: "40px",
// //             px: 3,
// //             py: 1.2,
// //             textTransform: "none",
// //             fontWeight: 600,
// //             background: "#fff",
// //             color: "#0c8a9b",
// //             boxShadow: `0 4px 14px ${alpha(BLUE[500], 0.25)}`,
// //             "&:hover": {
// //               transform: "translateY(-2px)",
// //               boxShadow: `0 8px 20px ${alpha("#0c8a9b", 0.35)}`,
// //               background: "#ace8f0",
// //               color: "#fff",
// //             },
// //             transition: "all 0.2s ease",
// //           }}
// //         >
// //           Create New Job
// //         </Button>
// //       </Box>

// //       {loading ? (
// //         <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
// //           <CircularProgress sx={{ color: BLUE[600] }} />
// //         </Box>
// //       ) : error ? (
// //         <Alert severity="error" sx={{ borderRadius: "20px" }}>
// //           {error}
// //         </Alert>
// //       ) : jobs.length === 0 ? (
// //         <Box
// //           sx={{
// //             textAlign: "center",
// //             py: 8,
// //             bgcolor: "#ffffff",
// //             borderRadius: "32px",
// //             border: `1px solid ${BLUE[100]}`,
// //             boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
// //             animation: "fadeUp 0.5s ease both",
// //           }}
// //         >
// //           <WorkOutlineIcon sx={{ fontSize: 64, color: BLUE[200], mb: 2 }} />
// //           <Typography
// //             variant="h6"
// //             fontWeight={600}
// //             color="#0f172a"
// //             gutterBottom
// //           >
// //             No jobs created yet
// //           </Typography>
// //           <Typography variant="body2" color="#64748b">
// //             Click "Create New Job" to start hiring
// //           </Typography>
// //         </Box>
// //       ) : (
// //         <Grid container spacing={3}>
// //           {jobs.map((job, idx) => (
// //             <Grid
// //               item
// //               xs={12}
// //               sm={6}
// //               md={4}
// //               key={job.id}
// //               sx={{ animation: `fadeUp 0.4s ease ${idx * 0.05}s both` }}
// //             >
// //               <JobCard
// //                 job={job}
// //                 onViewCandidates={() => navigate(`/ats/job/${job.id}`)}
// //                 onEdit={(selectedJob) => {
// //                   setEditJob(selectedJob);
// //                   setModalOpen(true);
// //                 }}
// //               />
// //             </Grid>
// //           ))}
// //         </Grid>
// //       )}

// //       <JobCreationModal
// //         open={modalOpen}
// //         onClose={() => {
// //           setModalOpen(false);
// //           setEditJob(null);
// //         }}
// //         job={editJob}
// //         onCreated={handleJobCreated}
// //         onUpdated={handleJobUpdated}
// //       />
// //     </Box>
// //   );
// // };

// // export default Dashboard;
// // // pages/Dashboard.js – Redesigned to match Hiring Bible reference UI
// // import { useState, useEffect, useCallback } from "react";
// // import { useNavigate } from "react-router-dom";
// // import {
// //   Box,
// //   Typography,
// //   Button,
// //   Grid,
// //   CircularProgress,
// //   Alert,
// // } from "@mui/material";
// // import AddIcon from "@mui/icons-material/Add";
// // import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// // import { useATS } from "../context/ATSContext";
// // import { jobService } from "../services/jobService";
// // import JobCard from "../components/JobCard";
// // import JobCreationModal from "../components/JobCreationModal";

// // const STYLE_ID = "hb-dashboard-styles";
// // if (typeof document !== "undefined" && !document.getElementById(STYLE_ID)) {
// //   const s = document.createElement("style");
// //   s.id = STYLE_ID;
// //   s.textContent = `
// //     @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

// //     @keyframes hbFadeUp {
// //       from { opacity: 0; transform: translateY(16px); }
// //       to { opacity: 1; transform: translateY(0); }
// //     }

// //     .hb-dashboard {
// //       min-height: 100vh;
// //       background: #f3f4f6;
// //       font-family: 'Inter', -apple-system, sans-serif;
// //       padding: 32px 40px;
// //     }

// //     .hb-dashboard-header {
// //       display: flex;
// //       justify-content: space-between;
// //       align-items: flex-start;
// //       margin-bottom: 28px;
// //       flex-wrap: wrap;
// //       gap: 16px;
// //       animation: hbFadeUp 0.35s ease both;
// //     }

// //     .hb-dashboard-title {
// //       font-family: 'Inter', sans-serif !important;
// //       font-weight: 800 !important;
// //       font-size: 28px !important;
// //       color: #111827 !important;
// //       line-height: 1.2 !important;
// //       letter-spacing: -0.5px !important;
// //       margin-bottom: 4px !important;
// //     }

// //     .hb-dashboard-subtitle {
// //       font-family: 'Inter', sans-serif !important;
// //       font-size: 13.5px !important;
// //       color: #6b7280 !important;
// //     }

// //     .hb-create-btn {
// //       display: flex;
// //       align-items: center;
// //       gap: 6px;
// //       padding: 10px 20px;
// //       border-radius: 40px;
// //       border: none;
// //       background: #0d9488;
// //       color: #ffffff;
// //       font-family: 'Inter', sans-serif;
// //       font-size: 14px;
// //       font-weight: 600;
// //       cursor: pointer;
// //       transition: background 0.15s, transform 0.15s, box-shadow 0.15s;
// //       box-shadow: 0 2px 8px rgba(13,148,136,0.3);
// //       white-space: nowrap;
// //     }

// //     .hb-create-btn:hover {
// //       background: #0f766e;
// //       transform: translateY(-1px);
// //       box-shadow: 0 4px 14px rgba(13,148,136,0.35);
// //     }

// //     .hb-create-btn svg { font-size: 18px !important; }

// //     /* Post new opening placeholder card */
// //     .hb-post-new-card {
// //       border-radius: 16px;
// //       border: 2px dashed #d1d5db;
// //       background: #f9fafb;
// //       display: flex;
// //       flex-direction: column;
// //       align-items: center;
// //       justify-content: center;
// //       gap: 10px;
// //       padding: 40px 24px;
// //       cursor: pointer;
// //       transition: border-color 0.15s, background 0.15s;
// //       min-height: 220px;
// //       height: 100%;
// //       text-align: center;
// //     }

// //     .hb-post-new-card:hover {
// //       border-color: #0d9488;
// //       background: rgba(13,148,136,0.03);
// //     }

// //     .hb-post-new-icon {
// //       width: 48px;
// //       height: 48px;
// //       border-radius: 50%;
// //       background: rgba(13,148,136,0.08);
// //       display: flex;
// //       align-items: center;
// //       justify-content: center;
// //       color: #0d9488;
// //     }

// //     .hb-post-new-title {
// //       font-family: 'Inter', sans-serif;
// //       font-size: 14px;
// //       font-weight: 600;
// //       color: #0d9488;
// //     }

// //     .hb-post-new-sub {
// //       font-family: 'Inter', sans-serif;
// //       font-size: 12.5px;
// //       color: #9ca3af;
// //       line-height: 1.4;
// //     }

// //     .hb-empty-state {
// //       text-align: center;
// //       padding: 64px 32px;
// //       background: #ffffff;
// //       border-radius: 16px;
// //       border: 1px solid #e5e7eb;
// //       animation: hbFadeUp 0.4s ease both;
// //     }
// //   `;
// //   document.head.appendChild(s);
// // }

// // const Dashboard = () => {
// //   const navigate = useNavigate();
// //   const { store_id, refreshTrigger } = useATS();
// //   const [jobs, setJobs] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [editJob, setEditJob] = useState(null);

// //   const fetchJobs = useCallback(async () => {
// //     if (store_id === undefined) return;
// //     try {
// //       setLoading(true);
// //       const response = await jobService.getAllJobs(store_id);
// //       setJobs(response.data.data || []);
// //       setError(null);
// //     } catch (err) {
// //       console.error(err);
// //       setError("Failed to load jobs. Please try again.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [store_id]);

// //   useEffect(() => {
// //     fetchJobs();
// //   }, [fetchJobs, refreshTrigger]);

// //   const handleCreateJob = () => {
// //     setEditJob(null);
// //     setModalOpen(true);
// //   };

// //   const handleJobCreated = () => {
// //     fetchJobs();
// //     setModalOpen(false);
// //     setEditJob(null);
// //   };

// //   const handleJobUpdated = () => {
// //     fetchJobs();
// //     setModalOpen(false);
// //     setEditJob(null);
// //   };

// //   if (store_id === undefined) {
// //     return (
// //       <div className="hb-dashboard">
// //         <div className="hb-empty-state">
// //           <Typography
// //             sx={{ fontFamily: "'Inter', sans-serif", color: "#6b7280" }}
// //           >
// //             Please log in to access the ATS dashboard.
// //           </Typography>
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="hb-dashboard">
// //       {/* Header */}
// //       <div className="hb-dashboard-header">
// //         <div>
// //           <Typography className="hb-dashboard-title">
// //             Active Vacancies
// //           </Typography>
// //           <Typography className="hb-dashboard-subtitle">
// //             Manage your active recruitment pipelines and candidate flow.
// //           </Typography>
// //         </div>

// //         <button className="hb-create-btn" onClick={handleCreateJob}>
// //           <AddIcon />
// //           Create New Job
// //         </button>
// //       </div>

// //       {loading ? (
// //         <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
// //           <CircularProgress sx={{ color: "#0d9488" }} />
// //         </Box>
// //       ) : error ? (
// //         <Alert severity="error" sx={{ borderRadius: "12px" }}>
// //           {error}
// //         </Alert>
// //       ) : jobs.length === 0 ? (
// //         <div className="hb-empty-state">
// //           <Typography
// //             sx={{
// //               fontWeight: 600,
// //               fontSize: 16,
// //               color: "#111827",
// //               mb: 1,
// //               fontFamily: "'Inter', sans-serif",
// //             }}
// //           >
// //             No jobs created yet
// //           </Typography>
// //           <Typography
// //             sx={{
// //               fontSize: 13.5,
// //               color: "#6b7280",
// //               fontFamily: "'Inter', sans-serif",
// //               mb: 3,
// //             }}
// //           >
// //             Click "Create New Job" to start hiring
// //           </Typography>
// //           <button
// //             className="hb-create-btn"
// //             onClick={handleCreateJob}
// //             style={{ margin: "0 auto" }}
// //           >
// //             <AddIcon />
// //             Create New Job
// //           </button>
// //         </div>
// //       ) : (
// //         <Grid container spacing={2.5}>
// //           {jobs.map((job, idx) => (
// //             <Grid
// //               item
// //               xs={12}
// //               sm={6}
// //               md={4}
// //               key={job.id}
// //               sx={{ animation: `hbFadeUp 0.35s ease ${idx * 0.04}s both` }}
// //             >
// //               <JobCard
// //                 job={job}
// //                 onViewCandidates={() => navigate(`/ats/job/${job.id}`)}
// //                 onEdit={(selectedJob) => {
// //                   setEditJob(selectedJob);
// //                   setModalOpen(true);
// //                 }}
// //               />
// //             </Grid>
// //           ))}

// //           {/* Post New Opening placeholder */}
// //           <Grid
// //             item
// //             xs={12}
// //             sm={6}
// //             md={4}
// //             sx={{
// //               animation: `hbFadeUp 0.35s ease ${jobs.length * 0.04}s both`,
// //             }}
// //           >
// //             <div className="hb-post-new-card" onClick={handleCreateJob}>
// //               <div className="hb-post-new-icon">
// //                 <AddCircleOutlineIcon sx={{ fontSize: 26 }} />
// //               </div>
// //               <div className="hb-post-new-title">Post New Opening</div>
// //               <div className="hb-post-new-sub">
// //                 Expand your team with a new job listing.
// //               </div>
// //             </div>
// //           </Grid>
// //         </Grid>
// //       )}

// //       <JobCreationModal
// //         open={modalOpen}
// //         onClose={() => {
// //           setModalOpen(false);
// //           setEditJob(null);
// //         }}
// //         job={editJob}
// //         onCreated={handleJobCreated}
// //         onUpdated={handleJobUpdated}
// //       />
// //     </div>
// //   );
// // };

// // export default Dashboard;
// import { useState, useEffect, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { Box, Typography, CircularProgress, Alert, Grid } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useATS } from "../context/ATSContext";
// import { jobService } from "../services/jobService";
// import JobCard from "../components/JobCard";
// import JobCreationForm from "../components/JobCreationModal";

// const STYLE_ID = "hb-dashboard-styles";
// if (typeof document !== "undefined" && !document.getElementById(STYLE_ID)) {
//   const s = document.createElement("style");
//   s.id = STYLE_ID;
//   s.textContent = `
//     @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

//     @keyframes hbFadeUp {
//       from { opacity: 0; transform: translateY(16px); }
//       to   { opacity: 1; transform: translateY(0); }
//     }

//     .hb-dashboard {
//     border-radius:16px;
//      min-height: 80vh;
//       background: #f3f4f6;
//       font-family: 'Inter', -apple-system, sans-serif;
//       padding: 32px 40px;
//     }

//     .hb-dashboard-header {
//       display: flex;
//       justify-content: space-between;
//       align-items: flex-start;
//       margin-bottom: 22px;
//       flex-wrap: wrap;
//       gap: 16px;
//       animation: hbFadeUp 0.35s ease both;
//     }

//     .hb-dashboard-title {
//       font-family: 'Inter', sans-serif !important;
//       font-weight: 800 !important;
//       font-size: 28px !important;
//       color: #111827 !important;
//       line-height: 1.2 !important;
//       letter-spacing: -0.5px !important;
//       margin-bottom: 4px !important;
//     }

//     .hb-dashboard-subtitle {
//       font-family: 'Inter', sans-serif !important;
//       font-size: 13.5px !important;
//       color: #6b7280 !important;
//     }

//     .hb-create-btn {
//       display: flex;
//       align-items: center;
//       gap: 6px;
//       padding: 10px 20px;
//       border-radius: 40px;
//       border: none;
//       background: #0d9488;
//       color: #ffffff;
//       font-family: 'Inter', sans-serif;
//       font-size: 14px;
//       font-weight: 600;
//       cursor: pointer;
//       transition: background 0.15s, transform 0.15s, box-shadow 0.15s;
//       box-shadow: 0 2px 8px rgba(13,148,136,0.3);
//       white-space: nowrap;
//     }

//     .hb-create-btn:hover {
//       background: #0f766e;
//       transform: translateY(-1px);
//       box-shadow: 0 4px 14px rgba(13,148,136,0.35);
//     }

//     .hb-create-btn svg { font-size: 18px !important; }

//     .hb-back-btn {
//       display: flex;
//       align-items: center;
//       gap: 6px;
//       padding: 8px 18px;
//       border-radius: 40px;
//       border: 1.5px solid #e2e8f0;
//       background: #ffffff;
//       color: #374151;
//       font-family: 'Inter', sans-serif;
//       font-size: 13.5px;
//       font-weight: 600;
//       cursor: pointer;
//       transition: background 0.15s, border-color 0.15s;
//     }

//     .hb-back-btn:hover {
//       background: #f8fafc;
//       border-color: #cbd5e1;
//     }

//     .hb-post-new-card {
//       border-radius: 16px;
//       border: 2px dashed #d1d5db;
//       background: #f9fafb;
//       display: flex;
//       flex-direction: column;
//       align-items: center;
//       justify-content: center;
//       gap: 10px;
//       padding: 40px 24px;
//       cursor: pointer;
//       transition: border-color 0.15s, background 0.15s;
//       min-height: 220px;
//       height: 100%;
//       text-align: center;
//     }

//     .hb-post-new-card:hover {
//       border-color: #0d9488;
//       background: rgba(13,148,136,0.03);
//     }

//     .hb-post-new-icon {
//       width: 48px;
//       height: 48px;
//       border-radius: 50%;
//       background: rgba(13,148,136,0.08);
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       color: #0d9488;
//     }

//     .hb-post-new-title {
//       font-family: 'Inter', sans-serif;
//       font-size: 14px;
//       font-weight: 600;
//       color: #0d9488;
//     }

//     .hb-post-new-sub {
//       font-family: 'Inter', sans-serif;
//       font-size: 12.5px;
//       color: #9ca3af;
//       line-height: 1.4;
//     }

//     .hb-empty-state {
//       text-align: center;
//       padding: 64px 32px;
//       background: #ffffff;
//       border-radius: 16px;
//       border: 1px solid #e5e7eb;
//       animation: hbFadeUp 0.4s ease both;
//     }
//   `;
//   document.head.appendChild(s);
// }

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const { store_id, refreshTrigger } = useATS();
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // "creating" = show form for new job, "editing" = show form for existing job
//   const [formMode, setFormMode] = useState(null); // null | "creating" | "editing"
//   const [editJob, setEditJob] = useState(null);

//   const fetchJobs = useCallback(async () => {
//     if (store_id === undefined) return;
//     try {
//       setLoading(true);
//       const response = await jobService.getAllJobs(store_id);
//       setJobs(response.data.data || []);
//       setError(null);
//     } catch (err) {
//       console.error(err);
//       setError("Failed to load jobs. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   }, [store_id]);

//   useEffect(() => {
//     fetchJobs();
//   }, [fetchJobs, refreshTrigger]);

//   const handleOpenCreate = () => {
//     setEditJob(null);
//     setFormMode("creating");
//   };

//   const handleOpenEdit = (selectedJob) => {
//     setEditJob(selectedJob);
//     setFormMode("editing");
//   };

//   const handleCancel = () => {
//     setFormMode(null);
//     setEditJob(null);
//   };

//   const handleJobCreated = () => {
//     fetchJobs();
//     setFormMode(null);
//     setEditJob(null);
//   };

//   const handleJobUpdated = () => {
//     fetchJobs();
//     setFormMode(null);
//     setEditJob(null);
//   };

//   if (store_id === undefined) {
//     return (
//       <div className="hb-dashboard">
//         <div className="hb-empty-state">
//           <Typography
//             sx={{ fontFamily: "'Inter', sans-serif", color: "#6b7280" }}
//           >
//             Please log in to access the ATS dashboard.
//           </Typography>
//         </div>
//       </div>
//     );
//   }

//   const showingForm = formMode === "creating" || formMode === "editing";

//   return (
//     <div className="hb-dashboard">
//       {/* ── Header ── */}
//       <div className="hb-dashboard-header">
//         <div>
//           {showingForm ? (
//             <>
//               <Typography className="hb-dashboard-title">
//                 {formMode === "editing" ? "Edit Job" : "Active Vacancies"}
//               </Typography>
//               <Typography className="hb-dashboard-subtitle">
//                 {formMode === "editing"
//                   ? "Update the details of this job posting."
//                   : "Manage your active recruitment pipelines and candidate flow."}
//               </Typography>
//             </>
//           ) : (
//             <>
//               <Typography className="hb-dashboard-title">
//                 Active Vacancies
//               </Typography>
//               <Typography className="hb-dashboard-subtitle">
//                 Manage your active recruitment pipelines and candidate flow.
//               </Typography>
//             </>
//           )}
//         </div>

//         {/* Right side buttons */}
//         {showingForm ? (
//           <button className="hb-back-btn" onClick={handleCancel}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} />
//             Back to Jobs
//           </button>
//         ) : (
//           <button className="hb-create-btn" onClick={handleOpenCreate}>
//             <AddIcon />
//             Create New Job
//           </button>
//         )}
//       </div>

//       {/* ── Form view ── */}
//       {showingForm && (
//         <Box sx={{ animation: "hbFadeUp 0.3s ease both" }}>
//           <JobCreationForm
//             job={editJob}
//             onCreated={handleJobCreated}
//             onUpdated={handleJobUpdated}
//             onCancel={handleCancel}
//           />
//         </Box>
//       )}

//       {/* ── Jobs grid view ── */}
//       {!showingForm && (
//         <>
//           {loading ? (
//             <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
//               <CircularProgress sx={{ color: "#0d9488" }} />
//             </Box>
//           ) : error ? (
//             <Alert severity="error" sx={{ borderRadius: "12px" }}>
//               {error}
//             </Alert>
//           ) : jobs.length === 0 ? (
//             <div className="hb-empty-state">
//               <Typography
//                 sx={{
//                   fontWeight: 600,
//                   fontSize: 16,
//                   color: "#111827",
//                   mb: 1,
//                   fontFamily: "'Inter', sans-serif",
//                 }}
//               >
//                 No jobs created yet
//               </Typography>
//               <Typography
//                 sx={{
//                   fontSize: 13.5,
//                   color: "#6b7280",
//                   fontFamily: "'Inter', sans-serif",
//                   mb: 3,
//                 }}
//               >
//                 Click "Create New Job" to start hiring
//               </Typography>
//               <button
//                 className="hb-create-btn"
//                 onClick={handleOpenCreate}
//                 style={{ margin: "0 auto" }}
//               >
//                 <AddIcon /> Create New Job
//               </button>
//             </div>
//           ) : (
//             <Grid container spacing={2.5}>
//               {jobs.map((job, idx) => (
//                 <Grid
//                   item
//                   xs={12}
//                   sm={6}
//                   md={4}
//                   key={job.id}
//                   sx={{ animation: `hbFadeUp 0.35s ease ${idx * 0.04}s both` }}
//                 >
//                   <JobCard
//                     job={job}
//                     onViewCandidates={() => navigate(`/ats/job/${job.id}`)}
//                     onEdit={(selectedJob) => handleOpenEdit(selectedJob)}
//                   />
//                 </Grid>
//               ))}

//               {/* Post New Opening placeholder */}
//               <Grid
//                 item
//                 xs={12}
//                 sm={6}
//                 md={4}
//                 sx={{
//                   animation: `hbFadeUp 0.35s ease ${jobs.length * 0.04}s both`,
//                 }}
//               >
//                 <div className="hb-post-new-card" onClick={handleOpenCreate}>
//                   <div className="hb-post-new-icon">
//                     <AddCircleOutlineIcon sx={{ fontSize: 26 }} />
//                   </div>
//                   <div className="hb-post-new-title">Post New Opening</div>
//                   <div className="hb-post-new-sub">
//                     Expand your team with a new job listing.
//                   </div>
//                 </div>
//               </Grid>
//             </Grid>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default Dashboard;
// DASHBOARD.jsx

import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Grid,
  Avatar,
  Card,
  Chip,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useATS } from "../context/ATSContext";
import { jobService } from "../services/jobService";

import JobCard from "../components/JobCard";
import JobCreationForm from "../components/JobCreationModal";
import { departmentService } from "../services/departmentService";

const STYLE_ID = "hb-dashboard-new-ui";

if (typeof document !== "undefined" && !document.getElementById(STYLE_ID)) {
  const style = document.createElement("style");

  style.id = STYLE_ID;

  style.textContent = `
  
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

  :root{
    --hb-primary:#0b8a8f;
    --hb-primary-dark:#08777b;
    --hb-bg:#f5f7fb;
    --hb-card:#ffffff;
    --hb-border:#e9edf5;
    --hb-text:#101828;
    --hb-muted:#667085;
    --hb-font:'Inter',sans-serif;
  }

  @keyframes hbFadeUp{
    from{
      opacity:0;
      transform:translateY(18px);
    }
    to{
      opacity:1;
      transform:translateY(0px);
    }
  }

  .hb-dashboard{
    min-height:100vh;
    background:var(--hb-bg);
    border-radius:18px;
    padding:32px;
    font-family:var(--hb-font);
  }

  .hb-dashboard-header{
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
    gap:24px;
    margin-bottom:34px;
    flex-wrap:wrap;
    animation:hbFadeUp .4s ease both;
  }

  .hb-welcome-title{
    font-size:42px !important;
    font-weight:800 !important;
    color:var(--hb-text);
    font-family:var(--hb-font) !important;
    line-height:1.1 !important;
    letter-spacing:-1px !important;
    margin-bottom:10px !important;
  }

  .hb-welcome-subtitle{
    font-size:15px !important;
    color:var(--hb-muted);
    line-height:1.7 !important;
    font-family:var(--hb-font) !important;
  }

  .hb-highlight{
    color:var(--hb-primary);
    font-weight:700;
  }

  .hb-create-btn{
    height:52px;
    border:none;
    border-radius:14px;
    background:var(--hb-primary);
    color:#fff;
    padding:0 24px;
    display:flex;
    align-items:center;
    gap:10px;
    cursor:pointer;
    font-size:14px;
    font-weight:700;
    font-family:var(--hb-font);
    transition:.2s ease;
    box-shadow:0 8px 24px rgba(11,138,143,.18);
  }

  .hb-create-btn:hover{
    background:var(--hb-primary-dark);
    transform:translateY(-2px);
  }

  .hb-back-btn{
    height:48px;
    border-radius:14px;
    border:1px solid var(--hb-border);
    background:#fff;
    padding:0 20px;
    display:flex;
    align-items:center;
    gap:8px;
    cursor:pointer;
    font-family:var(--hb-font);
    font-size:14px;
    font-weight:700;
    color:#344054;
  }

  .hb-stats-grid{
    margin-bottom:36px;
  }

  .hb-stat-card{
    background:#fff;
    border:1px solid var(--hb-border);
    border-radius:24px;
    padding:22px;
    display:flex;
    flex-direction:column;
    gap:14px;
    box-shadow:0 2px 10px rgba(16,24,40,.04);
    animation:hbFadeUp .45s ease both;
    transition:.22s ease;
    height:100%;
  }

  .hb-stat-card:hover{
    transform:translateY(-3px);
    box-shadow:0 10px 26px rgba(16,24,40,.08);
  }

  .hb-stat-top{
    display:flex;
    justify-content:space-between;
    align-items:flex-start;
  }

  .hb-stat-icon{
    width:52px;
    height:52px;
    border-radius:16px;
    display:flex;
    align-items:center;
    justify-content:center;
  }

  .hb-stat-growth{
    font-size:12px;
    font-weight:700;
    font-family:var(--hb-font);
  }

  .hb-stat-label{
    font-size:12px;
    text-transform:uppercase;
    letter-spacing:.08em;
    color:#98a2b3;
    font-weight:700;
    font-family:var(--hb-font);
  }

  .hb-stat-value{
    font-size:42px;
    line-height:1;
    color:var(--hb-text);
    font-weight:800;
    font-family:var(--hb-font);
  }

  .hb-section-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    margin-bottom:20px;
    animation:hbFadeUp .5s ease both;
  }

  .hb-section-title{
    font-size:32px !important;
    font-weight:800 !important;
    color:var(--hb-text);
    font-family:var(--hb-font) !important;
    letter-spacing:-0.5px;
  }

  .hb-view-all{
    display:flex;
    align-items:center;
    gap:6px;
    color:var(--hb-primary);
    font-weight:700;
    font-size:14px;
    font-family:var(--hb-font);
    cursor:pointer;
  }

  .hb-empty-state{
    background:#fff;
    border:1px solid var(--hb-border);
    border-radius:24px;
    padding:70px 32px;
    text-align:center;
  }

  .hb-post-new-card{
    border-radius:24px;
    border:2px dashed #d0d5dd;
    background:#fcfcfd;
    // min-height:320px;
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction:column;
    text-align:center;
    cursor:pointer;
    transition:.22s ease;
    padding:24px;
  }

  .hb-post-new-card:hover{
    border-color:var(--hb-primary);
    background:#f5fffe;
    transform:translateY(-3px);
  }

  .hb-post-new-icon{
    width:74px;
    height:74px;
    border-radius:50%;
    background:rgba(11,138,143,.08);
    display:flex;
    align-items:center;
    justify-content:center;
    color:var(--hb-primary);
    margin-bottom:18px;
  }

  .hb-post-new-title{
    font-size:18px;
    font-weight:800;
    color:var(--hb-text);
    margin-bottom:8px;
    font-family:var(--hb-font);
  }

  .hb-post-new-sub{
    font-size:14px;
    color:var(--hb-muted);
    line-height:1.6;
    font-family:var(--hb-font);
    max-width:230px;
  }

  @media (max-width:768px){

    .hb-dashboard{
      padding:20px;
    }

    .hb-welcome-title{
      font-size:32px !important;
    }

    .hb-section-title{
      font-size:24px !important;
    }

    .hb-stat-value{
      font-size:34px;
    }
  }

  `;
  document.head.appendChild(style);
}

const StatCard = ({ icon, label, value, growth, growthColor, iconBg }) => {
  return (
    <div className="hb-stat-card">
      <div className="hb-stat-top">
        <div
          className="hb-stat-icon"
          style={{
            background: iconBg,
          }}
        >
          {icon}
        </div>

        <div
          className="hb-stat-growth"
          style={{
            color: growthColor,
          }}
        >
          {growth}
        </div>
      </div>

      <div className="hb-stat-label">{label}</div>

      <div className="hb-stat-value">{value}</div>
    </div>
  );
};

const Dashboard = () => {
  const navigate = useNavigate();

  const { store_id, refreshTrigger, triggerRefresh } = useATS();

  const [jobs, setJobs] = useState([]);
  // Departments a job can belong to, for the filter below. Optional: if the
  // endpoint is unavailable the filter does not render and the dashboard
  // behaves exactly as it did before.
  const [departments, setDepartments] = useState([]);
  const [deptFilter, setDeptFilter] = useState("all");

  // Jobs carry the department they were opened under, so the dashboard can be
  // read one department at a time. "Unassigned" covers every job created before
  // the hierarchy existed, which is why it is a filter rather than a gap.
  const visibleJobs = jobs.filter((job) => {
    if (deptFilter === "all") return true;
    if (deptFilter === "unassigned") return !job.department_id;
    return Number(job.department_id) === Number(deptFilter);
  });

  const deptNameFor = (id) =>
    departments.find((dept) => Number(dept.id) === Number(id))?.name || null;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [formMode, setFormMode] = useState(null);
  const [editJob, setEditJob] = useState(null);

  const fetchJobs = useCallback(async () => {
    if (store_id === undefined) return;

    try {
      setLoading(true);

      const response = await jobService.getAllJobs(store_id);
      departmentService
        .getDepartmentsByStore(store_id, { includeCounts: false })
        .then((deptRes) => setDepartments(deptRes?.data?.data || []))
        .catch(() => setDepartments([]));

      setJobs(response.data.data || []);
      setError(null);
    } catch (err) {
      console.error(err);
      setError("Failed to load jobs. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [store_id]);

  useEffect(() => {
    fetchJobs();
  }, [fetchJobs, refreshTrigger]);

  const handleOpenCreate = () => {
    setEditJob(null);
    setFormMode("creating");
  };

  const handleOpenEdit = (selectedJob) => {
    setEditJob(selectedJob);
    setFormMode("editing");
  };

  const handleCancel = () => {
    setFormMode(null);
    setEditJob(null);
  };

  const handleJobCreated = () => {
    fetchJobs();
    setFormMode(null);
    setEditJob(null);
  };

  const handleJobUpdated = () => {
    fetchJobs();
    setFormMode(null);
    setEditJob(null);
  };

  const showingForm = formMode === "creating" || formMode === "editing";

  if (store_id === undefined) {
    return (
      <div className="hb-dashboard">
        <div className="hb-empty-state">
          <Typography
            sx={{
              fontFamily: "'Inter', sans-serif",
              color: "#667085",
            }}
          >
            Please log in to access the ATS dashboard.
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div className="hb-dashboard">
      {/* HEADER */}

      <div className="hb-dashboard-header">
        <div>
          {showingForm ? (
            <>
              <Typography className="hb-welcome-title">
                {formMode === "editing" ? "Edit Job" : "Create New Job"}
              </Typography>

              <Typography className="hb-welcome-subtitle">
                {formMode === "editing"
                  ? "Update the details of this job posting."
                  : "Create and manage recruitment openings for your organization."}
              </Typography>
            </>
          ) : (
            <>
              <Typography className="hb-welcome-title">Welcome back</Typography>

              <Typography className="hb-welcome-subtitle">
                Your recruitment pipeline is looking healthy. You have{" "}
                <span className="hb-highlight">
                  {jobs.filter((j) => j.status === "ACTIVE").length} active
                  roles
                </span>{" "}
                and{" "}
                <span className="hb-highlight">
                  {jobs.reduce(
                    (acc, job) => acc + (job.candidate_count || 0),
                    0,
                  )}{" "}
                  candidates
                </span>{" "}
                in progress.
              </Typography>
            </>
          )}
        </div>

        {showingForm ? (
          <button className="hb-back-btn" onClick={handleCancel}>
            <ArrowBackIcon sx={{ fontSize: 18 }} />
            Back to Jobs
          </button>
        ) : (
          <button className="hb-create-btn" onClick={handleOpenCreate}>
            <AddIcon sx={{ fontSize: 20 }} />
            Post New Job
          </button>
        )}
      </div>

      {/* FORM */}

      {showingForm && (
        <Box sx={{ animation: "hbFadeUp .4s ease both" }}>
          <JobCreationForm
            job={editJob}
            onCreated={handleJobCreated}
            onUpdated={handleJobUpdated}
            onCancel={handleCancel}
          />
        </Box>
      )}

      {/* DASHBOARD VIEW */}

      {!showingForm && (
        <>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                py: 12,
              }}
            >
              <CircularProgress sx={{ color: "#0b8a8f" }} />
            </Box>
          ) : error ? (
            <Alert
              severity="error"
              sx={{
                borderRadius: "16px",
              }}
            >
              {error}
            </Alert>
          ) : (
            <>
              {/* STATS */}

              <Grid container spacing={3} className="hb-stats-grid">
                <Grid item xs={12} sm={6} md={3}>
                  <StatCard
                    label="Active Roles"
                    value={jobs.filter((j) => j.status === "ACTIVE").length}
                    growth="+2 this week"
                    growthColor="#0b8a8f"
                    iconBg="#E6F8F8"
                    icon={
                      <WorkOutlineIcon
                        sx={{
                          color: "#0b8a8f",
                          fontSize: 26,
                        }}
                      />
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <StatCard
                    label="Total Candidates"
                    value={jobs.reduce(
                      (acc, job) => acc + (job.candidate_count || 0),
                      0,
                    )}
                    growth="+48 new"
                    growthColor="#CA8A04"
                    iconBg="#FEF3C7"
                    icon={
                      <Groups2OutlinedIcon
                        sx={{
                          color: "#CA8A04",
                          fontSize: 26,
                        }}
                      />
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <StatCard
                    label="Hiring Pipelines"
                    value={jobs.length}
                    growth="82% goal"
                    growthColor="#667085"
                    iconBg="#EEF2FF"
                    icon={
                      <PersonSearchOutlinedIcon
                        sx={{
                          color: "#6366F1",
                          fontSize: 26,
                        }}
                      />
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <StatCard
                    label="Time To Hire"
                    value="18"
                    growth="-2 days"
                    growthColor="#DC2626"
                    iconBg="#FEE2E2"
                    icon={
                      <AccessTimeOutlinedIcon
                        sx={{
                          color: "#DC2626",
                          fontSize: 26,
                        }}
                      />
                    }
                  />
                </Grid>
              </Grid>

              {/* ACTIVE JOBS */}

              <div className="hb-section-header">
                <Typography className="hb-section-title">
                  Active Jobs
                </Typography>

                <div className="hb-view-all">
                  View All Jobs
                  <ArrowForwardIcon sx={{ fontSize: 18 }} />
                </div>
              </div>

              {departments.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    flexWrap: "wrap",
                    mb: 2.5,
                  }}
                >
                  {[
                    { value: "all", label: `All · ${jobs.length}` },
                    ...(jobs.some((job) => !job.department_id)
                      ? [
                          {
                            value: "unassigned",
                            label: `Unassigned · ${
                              jobs.filter((job) => !job.department_id).length
                            }`,
                          },
                        ]
                      : []),
                    ...departments
                      .map((dept) => ({
                        value: String(dept.id),
                        label: dept.name,
                        count: jobs.filter(
                          (job) =>
                            Number(job.department_id) === Number(dept.id),
                        ).length,
                      }))
                      // A department with no jobs adds a chip that filters to an
                      // empty screen, so it is left out until it has one.
                      .filter((chip) => chip.count > 0)
                      .map((chip) => ({
                        value: chip.value,
                        label: `${chip.label} · ${chip.count}`,
                      })),
                  ].map((chip) => {
                    const active = deptFilter === chip.value;
                    return (
                      <Chip
                        key={chip.value}
                        label={chip.label}
                        onClick={() => setDeptFilter(chip.value)}
                        sx={{
                          fontFamily: "'Plus Jakarta Sans', 'Inter', sans-serif",
                          fontWeight: 600,
                          fontSize: 12.5,
                          cursor: "pointer",
                          bgcolor: active ? "#0c8a9b" : "#fff",
                          color: active ? "#fff" : "#475569",
                          border: `1px solid ${active ? "#0c8a9b" : "#e2e8f0"}`,
                          "&:hover": {
                            bgcolor: active ? "#0a7a8a" : "#f1f5f9",
                          },
                        }}
                      />
                    );
                  })}
                </Box>
              )}

              {jobs.length === 0 ? (
                <div className="hb-empty-state">
                  <Typography
                    sx={{
                      fontSize: "1.4rem",
                      fontWeight: 800,
                      color: "#101828",
                      fontFamily: "'Inter', sans-serif",
                      mb: 1,
                    }}
                  >
                    No jobs created yet
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "0.95rem",
                      color: "#667085",
                      fontFamily: "'Inter', sans-serif",
                      mb: 4,
                    }}
                  >
                    Start building your recruitment pipeline by creating your
                    first job posting.
                  </Typography>

                  <button
                    className="hb-create-btn"
                    onClick={handleOpenCreate}
                    style={{
                      margin: "0 auto",
                    }}
                  >
                    <AddIcon />
                    Create New Job
                  </button>
                </div>
              ) : (
                <Grid container spacing={3}>
                  {visibleJobs.map((job, idx) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      key={job.id}
                      sx={{
                        animation: `hbFadeUp .45s ease ${idx * 0.05}s both`,
                      }}
                    >
                      {/* Which part of the org opened this. Rendered here
                          rather than inside JobCard so the card keeps working
                          unchanged everywhere else it is used. */}
                      {job.department_id && deptNameFor(job.department_id) && (
                        <Typography
                          sx={{
                            fontFamily:
                              "'Plus Jakarta Sans', 'Inter', sans-serif",
                            fontSize: 11.5,
                            fontWeight: 700,
                            letterSpacing: "0.04em",
                            textTransform: "uppercase",
                            color: "#94a3b8",
                            mb: 0.6,
                            pl: 0.3,
                          }}
                        >
                          {deptNameFor(job.department_id)}
                        </Typography>
                      )}
                      <JobCard
                        job={job}
                        onViewCandidates={() => navigate(`/ats/job/${job.id}`)}
                        onEdit={(selectedJob) => handleOpenEdit(selectedJob)}
                        // A card can now close a job, empty it, or delete it.
                        // All three change the list this card is in, and a
                        // deleted job leaves a card behind until the list
                        // refetches.
                        onChanged={() => triggerRefresh()}
                      />
                    </Grid>
                  ))}

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                      animation: `hbFadeUp .45s ease ${
                        jobs.length * 0.05
                      }s both`,
                    }}
                  >
                    <div
                      className="hb-post-new-card"
                      onClick={handleOpenCreate}
                    >
                      <div className="hb-post-new-icon">
                        <AddCircleOutlineIcon
                          sx={{
                            fontSize: 34,
                          }}
                        />
                      </div>

                      <div className="hb-post-new-title">Post New Opening</div>

                      <div className="hb-post-new-sub">
                        Expand your hiring pipeline with a new job listing.
                      </div>
                    </div>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Dashboard;
